
class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange(event) {
        const currentVariant = this.currentVariant();
        if (currentVariant) {
            const bundle = event.currentTarget.closest('[js-recomemded-bundle]');
            const addToCartButtonsValue = bundle.querySelector("[js-hb-atc-value]");
            const addToCartButtonTexts = bundle.querySelector("[js-quick-add-to-cart-btn-text]");
            const comparePrice = bundle.querySelector('[js-compare-price]');
            const currentPrice = bundle.querySelector('[js-current-price]');
            const discountPrice = bundle.querySelector('[js-discount-price]');

            const discountPriceContainer = discountPrice.parentElement;
            addToCartButtonsValue.value = currentVariant.id;

            this.updateAddToCart(currentVariant, addToCartButtonTexts, bundle);

            currentPrice.textContent = theme.Currency.formatMoney(currentVariant.price);

            if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
                comparePrice.textContent = theme.Currency.formatMoney(currentVariant.compare_at_price);
                comparePrice.style.display = 'block';

                const currentDiscountPrice = currentVariant.compare_at_price - currentVariant.price;
                discountPrice.textContent = theme.Currency.formatMoney(currentDiscountPrice);
                discountPriceContainer.style.display = 'flex';
            } else {
                comparePrice.style.display = 'none';
                discountPriceContainer.style.display = 'none';
            }
        }
    }



    getVariantData() {
        return JSON.parse(this.querySelector('[type="application/json"]').textContent);
    }

    updateOptions() {
        return [...this.querySelectorAll('select')].map((select) => select.value);
    }

    currentVariant() {
        return this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.updateOptions()[index] === option;
            }).includes(false);
        });
    }

    updateAddToCart(currentVariant, buttonText, bundle) {
        const addToCartButtons = bundle.querySelectorAll("[js-hb-atc-btn]");
        if (currentVariant.available) {
            buttonText.innerText = "Hinzufügen";
            addToCartButtons.forEach(button => button.removeAttribute('disabled'));
        } else {
            buttonText.innerText = "Ausverkauft";
            addToCartButtons.forEach(button => button.setAttribute('disabled', 'true'));
        }
    }

}

customElements.define('variant-selects', VariantSelects);


class recomendedBundle extends HTMLElement {
    constructor() {
        super();
        this.mainCollection = document.querySelector('[js-main-collection]');
        this.desktopPosition = parseInt(this.dataset.desktopPosition);
        this.mobilePosition = parseInt(this.dataset.mobilePosition);
        this.init();
    }
    init() {
        this.appendBundle();
    }
    appendBundle() {
        const targetProductBundel = this.mainCollection.querySelector(`[js-product-grid] .product-item:nth-child(${document.documentElement.clientWidth > 767 ? this.desktopPosition : this.mobilePosition})`);
        if (targetProductBundel) {
            targetProductBundel.insertAdjacentHTML("beforebegin", this.innerHTML);
        }
    }
}
customElements.define('recomended-bundle', recomendedBundle);


class CustomBundle extends HTMLElement {
    constructor() {
        super()
        this.originalPrice = this.querySelector('[js-original-price]');
        this.RegularPrice = this.querySelectorAll('[js-regular-price]');
        this.savePrice = this.querySelector('[js-discount-price]');
        this.discountHalfPrice = this.querySelectorAll('[js-half-discount]');
        this.atcValue1 = this.querySelector('[js-hb-atc-value1]');
        this.atcValue2 = this.querySelector('[js-hb-atc-value2]');
        this.atcBtn = this.querySelector('[js-hb-atc-btn]');
        this.atcBtnText = this.querySelector('[js-quick-add-to-cart-btn-text]');
        this.discountPrice = this.querySelector('[js-total-discount]');
        this.product1VariantImage = this.querySelector('[js-product1-variant-image]');
        this.product2VariantImage = this.querySelector('[js-product2-variant-image]');
        this.product1VariantImageUrl = this.querySelector('[js-product1-variant-url]');
        this.product2VariantImageUrl = this.querySelector('[js-product2-variant-url]');
        this.customVariantSelectsWrapper = this.querySelectorAll('[js-custom-variant-select]');
        this.customVariantSelects = this.querySelectorAll('[js-custom-variant-select-btn]');
        this.dropdownValues = this.querySelectorAll('[js-dropdown-value]');

        document.body.addEventListener("click", (e) => {
            if (!e.target.hasAttribute("js-custom-variant-select-btn")) {
                this.closeDropdown();
            }
        })
        this.customVariantSelects.forEach(select => {
            select.addEventListener("click", this.openDropdown.bind(this));
        });

        this.dropdownValues.forEach(dropdownItem => {
            dropdownItem.addEventListener("click", ({ currentTarget }) => {
                const optionItem = currentTarget.closest("[js-option-item]");
                const select = optionItem.querySelector("select");
                const selectLabel = optionItem.querySelector("[js-selected-label]");
                const swatchEl = optionItem.querySelector("[js-swatch-color]");
                const value = currentTarget.getAttribute("data-value");
                const option = select.querySelector(`option[value='${value}']`);
                option.selected = true;

                currentTarget.classList.contains("is-color") ? this.updateSwatch(swatchEl, currentTarget) : null;
                this.updateLabel(selectLabel, value);
                this.dispatchEvent(new Event("change"));
                this.closeDropdown();
            })
        })

        this.addEventListener('change', () => {
            this.onVariantChange();
        });
    }
    updateSwatch(swatchEl, currentTarget) {
        if (currentTarget.hasAttribute("data-swatch-img")) {
            swatchEl.style.backgroundImage = `url('${currentTarget.getAttribute("data-swatch-img")}')`;
            swatchEl.style.backgroundColor = "";
        } else {
            swatchEl.style.backgroundImage = "";
            swatchEl.style.backgroundColor = `${currentTarget.getAttribute("data-swatch-color")}`;
        }
    }
    updateLabel(selectLabel, value) {
        selectLabel.textContent = value;
    }
    openDropdown({ currentTarget }) {
        const selectWrap = currentTarget.closest("[js-custom-variant-select]");

        this.customVariantSelectsWrapper.forEach(item => {
            if (item !== selectWrap) {
                item.classList.remove("active")
            }
        });
        selectWrap.classList.toggle('active');
    }
    closeDropdown() {
        this.customVariantSelectsWrapper.forEach(item => item.classList.remove("active"));
    }
    onVariantChange() {
        const currentVariants = this.currentVariants();
        const currentVariant1 = currentVariants.currentVariant1;
        const currentVariant2 = currentVariants.currentVariant2;


        const discount = parseFloat(this.discountPrice.dataset.discountPrice) || 0;
        const totalPrice = currentVariant1.price + currentVariant2.price;
        const discountAmount = (totalPrice * discount) / 100;
        const regularPrice = totalPrice - discountAmount;
        const savePrice = totalPrice - regularPrice;
        const halfDiscount = (savePrice / 2).toFixed();

        this.originalPrice.textContent = theme.Currency.formatMoney(totalPrice);
        this.savePrice.textContent = theme.Currency.formatMoney(savePrice);
        this.atcValue1.value = currentVariant1.id;
        this.atcValue2.value = currentVariant2.id;

        this.RegularPrice.forEach((regular) => {
            regular.textContent = theme.Currency.formatMoney(regularPrice);
        });
        this.discountHalfPrice.forEach((el) => {
            el.textContent = `-${theme.Currency.formatMoney(halfDiscount)}`;
        });
        if (currentVariant1.available && currentVariant2.available) {
            this.atcBtnText.textContent = 'Hinzufügen';
            this.atcBtn.removeAttribute('disabled');

        } else {
            this.atcBtnText.textContent = 'Ausverkauft';
            this.atcBtn.setAttribute('disabled', 'disabled');
        }
        this.product1VariantImage.src = currentVariant1.featured_image?.src || this.product1VariantImage.dataset.product1FeaturedImage;
        this.product2VariantImage.src = currentVariant2.featured_image?.src || this.product2VariantImage.dataset.product2FeaturedImage;

        const product1Url = this.product1VariantImageUrl.dataset.product1Url;
        const variant1Url = `${product1Url}?variant=${currentVariant1.id}`;
        this.product1VariantImageUrl.href = variant1Url
        const product2Url = this.product2VariantImageUrl.dataset.product2Url;
        const variant2Url = `${product2Url}?variant=${currentVariant2.id}`;
        this.product2VariantImageUrl.href = variant2Url


    }
    currentVariants() {
        const { productData1, productData2 } = this.getVariantData();
        const { product1Options, product2Options } = this.updateOptions();

        const currentVariant1 = productData1.find((variant) => {
            return !variant.options.map((option, index) => {
                return product1Options[index] === option;
            }).includes(false);
        });

        const currentVariant2 = productData2.find((variant) => {
            return !variant.options.map((option, index) => {
                return product2Options[index] === option;
            }).includes(false);
        });

        return { currentVariant1, currentVariant2 };
    }

    updateOptions() {
        const selectProductOptions1 = this.querySelectorAll('[js-product1] select');
        const selectProductOptions2 = this.querySelectorAll('[js-product2] select');

        const product1Options = [...selectProductOptions1].map((select) => select.value);
        const product2Options = [...selectProductOptions2].map((select) => select.value);

        return { product1Options, product2Options };
    }

    getVariantData() {
        const productJson1 = this.querySelector('[js-variant-data1]');
        const productJson2 = this.querySelector('[js-variant-data2]');

        const productData1 = productJson1 ? JSON.parse(productJson1.textContent) : [];
        const productData2 = productJson2 ? JSON.parse(productJson2.textContent) : [];

        return { productData1, productData2 };
    }
}

customElements.define('custom-bundle', CustomBundle)